import { render, staticRenderFns } from "./EditMarketPic.vue?vue&type=template&id=c8176094"
import script from "./EditMarketPic.vue?vue&type=script&lang=js"
export * from "./EditMarketPic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports